// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3udCB","info":"PatientInfo_info__nmbPv"};